import { z } from 'zod';

import { BooleanParamSchema } from '../../common/boolean-param/boolean-param';
import { makeListQuery } from '../../common/list-query/list-query';
import { NotificationCategorySchema } from '../notification-category/notification-category';
import { NotificationChannelSchema } from '../notification-channel/notification-channel';

/**
 * The whitelisted filters of the template list (N7).
 *
 * `search` matches the **key**, not the translated title: the key is the stable
 * identity, it is what a staff member can quote from a delivery-log row they are
 * looking at, and searching the copy would return different results depending on
 * which locale the searcher happened to be in.
 *
 * `isActive` is a strict `'true'|'false'` transform, never `z.coerce.boolean()`,
 * which reads `'false'` as `true` (N7).
 */
export const NotificationTemplatesListQuerySchema = makeListQuery({
  isActive: BooleanParamSchema.optional(),
  category: NotificationCategorySchema.optional(),
  channel: NotificationChannelSchema.optional(),
  search: z.string().trim().min(1).max(120).optional(),
});

export type NotificationTemplatesListQuery = z.infer<typeof NotificationTemplatesListQuerySchema>;
